import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import SliderController from './controllers/slider-controller';
import SelectController from './controllers/select-controller';

require('./navigation');
require('./lightbox');
require('./expand-content');
require('./misc');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('select', SelectController);